export interface ICustomsClearance {
  files?: {
    id: string;
    source: string;
    name: string;
    preview: string;
    createdAt: string;
  }[];
  id: string;
  state: string;
  order: {
    id: string;
  };
}

export enum CustomsClearanceState {
  NeedToReview = "Need to Review",
  Reviewed = "Reviewed",
  RequestSupplement = "Request supplement",
  NoRequired = "No required",
}
